import { Channel, channels } from 'lib-shared-types-channels';
import { useMemo } from 'react';

import { channelAttributes } from 'utils/channels';
import { getChannelFeatureFlagsStatus } from 'utils/featureFlagging/channelFeatureFlags';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { ConversationsStaticFilter } from '../static/conversationsStaticFilter';
import { ConversationsStaticFilterConfig } from '../static/conversationsStaticFilter.types';

const channelsOrdered: readonly Channel[] = [
  'widget_chat',
  'messenger',
  'pstn_phone',
  'voicemail',
  'contact_form',
  'email',
  'callback',
  'facebook_messenger',
  'whats_app',
  'twitter',
  'sms',
  'adachat',
  'digitalgeniuschat',
  'kindlychat',
  'trustpilotreviews',
];

/** Represents the component for filtering the conversations by channel. */
export const ConversationsChannelFilter = (): JSX.Element => {
  const { instagramManagement } = useFeatureFlag(['instagram-management']);
  const channelFlags = getChannelFeatureFlagsStatus();

  const items: readonly ConversationsStaticFilterConfig['channel'][] =
    useMemo(() => {
      return channels
        .filter((channel) => {
          if (channel === 'facebook_messenger') {
            // Instagram conversations appear as Facebook conversations
            return channelFlags.get(channel) || instagramManagement;
          }
          return channelFlags.get(channel);
        })
        .sort((a, b) => channelsOrdered.indexOf(a) - channelsOrdered.indexOf(b))
        .map((channel) => ({
          id: channel,
          icon: channelAttributes[channel].icon,
          name: channelAttributes[channel].name,
        }));
    }, [instagramManagement, channelFlags]);

  return <ConversationsStaticFilter type="channel" items={items} />;
};
